import React, { Component, Fragment, createRef } from "react";
import Axios from "axios";
import { Form } from "react-final-form";
import { connect } from "react-redux";
import { Field } from "react-final-form-html5-validation";
import { textField, textareaField } from "./helpers/Form";
import { OnChange } from "react-final-form-listeners";
import * as actions from "../actions";
import ReactTooltip from "react-tooltip";
import { useFormState } from "react-final-form";
import Loader from "react-loader-spinner";

import {
    isRequiredZipCodePAM,
    isRequiredText,
    isRequiredSelection,
    numberValidator,
    conditionallyRequiredPhoneNumber,
    isRequiredQuestionSelection,
    conditionallyRequired,
    isRequiredTextarea,
    conditionallyRequiredText,
    isRequiredPhoneNumber,
    isRequired,
} from "./helpers/Validation";

class PAMLookup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            found: false,
            searchBtn: "SEARCH",
            modalDisplay: "none",
            modalConfirmDisplay: "none",
            zip: "",
            data: "",
            FirstName: "firstname",
            loadingPAM: false,
        };
    }

    handleContactPopup() {
        this.setState({ ...this.state, modalDisplay: "block" });
    }

    submitPAMLookup(values) {
        const reactState = this;
        const zipCode = values.zip;
        document.getElementById("error").style.display = "none";
        const fetchData = async () => {
            this.setState({ ...this.state, loadingPAM: true });

            const result = await Axios({
                method: "get",
                url: `/api/pam_list/${zipCode}`,
            });

            if (result && result.data.city != "City") {
                this.setState({
                    found: true,
                    searchBtn: "UPDATE",
                    zip: zipCode,
                    data: result.data,
                    loadingPAM: false,
                });
            } else {
                this.setState({
                    found: false,
                    searchBtn: "UPDATE",
                    loadingPAM: false,
                });

                document.getElementById("error").style.display = "block";
            }
        };

        fetchData();
    }

    OnChange() {}

    closeConfirmModalDialog() {
        this.setState({ ...this.state, modalConfirmDisplay: "none" });
    }

    emailContactInfo(values) {
        this.setState({
            ...this.state,
            modalConfirmDisplay: "block",
            modalDisplay: "none",
        });

        let url = "/";
        if (process.env.NODE_ENV === "development") {
            url = "http://localhost:8000/";
        }

        const fetchData = async () => {
            try {
                const result = await Axios({
                    method: "post",
                    headers: {
                        "Content-type": "application/x-www-form-urlencoded",
                    },
                    url: url + "api/pam_email",
                    data: values,
                });
            } catch {}
        };

        fetchData();
    }

    closeModalDialog() {
        this.setState({ ...this.state, modalDisplay: "none" });
    }

    contactEmail = createRef();
    contactPhoneOne = createRef();
    contactPhoneTwo = createRef();
    contactPhoneThree = createRef();

    render() {
        const {
            preferredContact,
            contactPhoneOne,
            contactPhoneTwo,
            contactPhoneThree,
        } = this.props.questionOptions;

        return (
            <>
                <div className="container pam-finder-bg pam-desktop">
                    <div className="row">
                        <div className="col"></div>
                        <div className="col">
                            <div
                                className="acadia-form"
                                style={{
                                    paddingTop: "13%",
                                    paddingLeft: "17%",
                                }}
                            >
                                {!this.state.found &&
                                    !this.props.isResourcePage && (
                                        <>
                                            <h2 className="blue-font-35-gelo">
                                                contact your PAM.
                                            </h2>
                                        </>
                                    )}
                                {!this.state.found &&
                                    this.props.isResourcePage && (
                                        <>
                                            <h4>
                                                Patient Access Manager (PAM)
                                            </h4>
                                            <p
                                                style={{
                                                    paddingRight: "18px",
                                                    marginBottom: "0px",
                                                }}
                                            >
                                                The PAM supports your office by
                                                guiding through payer coverage,
                                                clarifying insurance
                                                requirements, and resolving
                                                access issues to minimize
                                                delays. They keep you informed
                                                about patients' insurance
                                                status, offer education on
                                                financial assistance, and alert
                                                you to any treatment
                                                interruptions for patients.
                                                <br />
                                                <br />
                                            </p>
                                        </>
                                    )}
                                {!this.state.found && (
                                    <>
                                        <p
                                            style={{
                                                paddingRight: "18px",
                                                marginBottom: "0px",
                                            }}
                                        >
                                            Enter your ZIP code to find your
                                            local PAM.
                                        </p>
                                    </>
                                )}
                                {this.state.found && (
                                    <>
                                        <h2 className="blue-font-35-gelo">
                                            your PAM is{" "}
                                            {this.state.data.firstName}.
                                        </h2>
                                        <p style={{ paddingRight: "18px" }}>
                                            Connect with{" "}
                                            {this.state.data.firstName} directly
                                            using our convenient contact form.
                                        </p>
                                        <div className="col pl-0">
                                            <button
                                                className="button blue"
                                                type="button"
                                                onClick={this.handleContactPopup.bind(
                                                    this
                                                )}
                                            >
                                                CONTACT{" "}
                                                {this.state.data.firstName}
                                            </button>
                                            <div
                                                style={{
                                                    paddingBottom: "46px",
                                                    borderBottom:
                                                        "1px solid var(--light-blue)",
                                                }}
                                            ></div>
                                        </div>
                                    </>
                                )}

                                <Form onSubmit={(v) => this.submitPAMLookup(v)}>
                                    {({ handleSubmit }) => (
                                        <form>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div
                                                        className={
                                                            "col lg-12 zip-search " +
                                                            (this.state.found
                                                                ? ""
                                                                : "zip-search-padding")
                                                        }
                                                    >
                                                        <Field
                                                            name="zip"
                                                            placeholder=""
                                                            component={
                                                                textField
                                                            }
                                                            validate={
                                                                isRequiredZipCodePAM
                                                            }
                                                            maxLength={5}
                                                            inputMode="numeric"
                                                            customInputClass={{
                                                                backgroundColor:
                                                                    "white",
                                                                height: "48px",
                                                                paddingLeft:
                                                                    "17px",
                                                                width: "94px",
                                                                padding:
                                                                    "6px 6px 6px 13px",
                                                            }}
                                                            customDivClass={{
                                                                display:
                                                                    "inline-block",
                                                                marginBottom:
                                                                    "0",
                                                                top: "-7px",
                                                                paddingRight:
                                                                    "10px",
                                                                paddingLeft:
                                                                    "0",
                                                            }}
                                                        />
                                                        <button
                                                            id="pam-zipcode-submit"
                                                            className={
                                                                "button blue d-inline-block"
                                                            }
                                                            type="button"
                                                            onClick={
                                                                handleSubmit
                                                            }
                                                        >
                                                            {
                                                                this.state
                                                                    .searchBtn
                                                            }
                                                            {this.state
                                                                .loadingPAM && (
                                                                <Loader
                                                                    type="ThreeDots"
                                                                    color="#FFF"
                                                                    height={15}
                                                                    width={35}
                                                                    className="loading-icon"
                                                                />
                                                            )}
                                                        </button>
                                                        <span
                                                            id="error"
                                                            className="error"
                                                            style={{
                                                                display: "none",
                                                                position:
                                                                    "relative",
                                                                top: "-47px",
                                                            }}
                                                        >
                                                            Invalid ZIP code
                                                        </span>
                                                        {this.state.found && (
                                                            <p
                                                                className="grey-font-13-euclid"
                                                                style={{
                                                                    display:
                                                                        "inline-block",
                                                                    width: "40%",
                                                                    fontSize:
                                                                        "10px",
                                                                    marginTop:
                                                                        "10px",
                                                                    paddingLeft:
                                                                        "10px",
                                                                    lineHeight:
                                                                        "13px",
                                                                }}
                                                            >
                                                                If this is not
                                                                your office's
                                                                ZIP code, enter
                                                                yours and click
                                                                the "Update"
                                                                button to
                                                                search.
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={
                                                            this.state
                                                                .modalDisplay ==
                                                            "block"
                                                                ? "found-pam-spacer"
                                                                : ""
                                                        }
                                                    ></div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile */}
                <div className="container pam-mobile">
                    <div className="row">
                        <div style={{ padding: "0px" }}>
                            <img
                                src="/images/pam-finder-background-short.png"
                                className="pam-mobile-img"
                                alt=""
                            />
                        </div>
                        <div className="pam-form-mobile">
                            <div
                                className="acadia-form"
                                style={{ paddingTop: "4%", paddingLeft: "4%" }}
                            >
                                {!this.state.found &&
                                    !this.props.isResourcePage && (
                                        <>
                                            <h2 className="blue-font-35-gelo">
                                                contact your PAM.
                                            </h2>
                                        </>
                                    )}
                                {!this.state.found &&
                                    this.props.isResourcePage && (
                                        <>
                                            <h4>
                                                Patient Access Manager (PAM)
                                            </h4>
                                            <p
                                                style={{
                                                    paddingRight: "18px",
                                                    marginBottom: "0px",
                                                }}
                                            >
                                                The PAM supports your office by
                                                guiding through payer coverage,
                                                clarifying insurance
                                                requirements, and resolving
                                                access issues to minimize
                                                delays. They keep you informed
                                                about patients' insurance
                                                status, offer education on
                                                financial assistance, and alert
                                                you to any treatment
                                                interruptions for patients.
                                                <br />
                                                <br />
                                            </p>
                                        </>
                                    )}
                                {!this.state.found && (
                                    <>
                                        <p style={{ paddingRight: "18px" }}>
                                            Enter your ZIP code to find your
                                            local PAM.
                                        </p>
                                    </>
                                )}
                                {this.state.found && (
                                    <>
                                        <h2 className="blue-font-35-gelo">
                                            your PAM is{" "}
                                            {this.state.data.firstName}.
                                        </h2>
                                        <p style={{ paddingRight: "18px" }}>
                                            Connect with{" "}
                                            {this.state.data.firstName} directly
                                            using our convenient contact form.
                                        </p>
                                        <div className="col pl-0">
                                            <button
                                                className="button blue"
                                                type="button"
                                                onClick={this.handleContactPopup.bind(
                                                    this
                                                )}
                                            >
                                                CONTACT{" "}
                                                {this.state.data.firstName}
                                            </button>
                                            <div
                                                style={{
                                                    paddingBottom: "79px",
                                                    borderBottom:
                                                        "1px solid var(--light-blue)",
                                                }}
                                            ></div>
                                        </div>
                                    </>
                                )}

                                <Form onSubmit={(v) => this.submitPAMLookup(v)}>
                                    {({ handleSubmit }) => (
                                        <form>
                                            <div className="form-group">
                                                <div className="row">
                                                    <div
                                                        className="col lg-12 zip-search"
                                                        style={{
                                                            paddingTop: "12px",
                                                        }}
                                                    >
                                                        <Field
                                                            name="zip"
                                                            placeholder=""
                                                            component={
                                                                textField
                                                            }
                                                            validate={
                                                                isRequiredZipCodePAM
                                                            }
                                                            maxLength={5}
                                                            inputMode="numeric"
                                                            customInputClass={{
                                                                backgroundColor:
                                                                    "white",
                                                                height: "48px",
                                                                paddingLeft:
                                                                    "17px",
                                                                width: "94px",
                                                                paddingTop:
                                                                    "6px",
                                                            }}
                                                            customDivClass={{
                                                                display:
                                                                    "inline-block",
                                                                marginBottom:
                                                                    "0",
                                                                top: "-7px",
                                                                paddingRight:
                                                                    "10px",
                                                                paddingLeft:
                                                                    "0",
                                                            }}
                                                        />
                                                        <button
                                                            className={
                                                                "button blue d-inline-block"
                                                            }
                                                            type="button"
                                                            onClick={
                                                                handleSubmit
                                                            }
                                                        >
                                                            {
                                                                this.state
                                                                    .searchBtn
                                                            }
                                                            {this.state
                                                                .loadingPAM && (
                                                                <Loader
                                                                    type="ThreeDots"
                                                                    color="#FFF"
                                                                    height={15}
                                                                    width={35}
                                                                    className="loading-icon"
                                                                />
                                                            )}
                                                        </button>
                                                        {this.state.found && (
                                                            <p
                                                                className="grey-font-13-euclid"
                                                                style={{
                                                                    display:
                                                                        "inline-block",
                                                                    width: "60%",
                                                                    fontSize:
                                                                        "10px",
                                                                    marginTop:
                                                                        "10px",
                                                                    paddingLeft:
                                                                        "10px",
                                                                    lineHeight:
                                                                        "13px",
                                                                }}
                                                            >
                                                                If this is not
                                                                your office's
                                                                ZIP code, enter
                                                                yours and click
                                                                the "Update"
                                                                button to
                                                                search.
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={
                                                            this.state
                                                                .modalDisplay ==
                                                            "block"
                                                                ? "found-pam-spacer"
                                                                : ""
                                                        }
                                                    ></div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Modals*/}
                <div
                    className="modal modal-fade"
                    id="contactInfo"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                    style={{ display: this.state.modalDisplay }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <div className="container blue-bg">
                                <div className="modal-header">
                                    <p
                                        className="modal-title white-font-26-euclid"
                                        id="exampleModalLongTitle"
                                    >
                                        Patient Access Manager CONTACT REQUEST
                                    </p>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={() => this.closeModalDialog()}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <p className="acadia-form form-group required-text">
                                    *Indicates required field.
                                </p>
                                <Form
                                    onSubmit={(v) => this.emailContactInfo(v)}
                                    subscription={{
                                        meta: true,
                                        values: true,
                                        submitting: true,
                                    }}
                                    render={({
                                        handleSubmit,
                                        form,
                                        submitting,
                                        pristine,
                                        values,
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <div className="acadia-form form-group">
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <Field
                                                            name="FirstName"
                                                            label="First name*"
                                                            component={
                                                                textField
                                                            }
                                                            validate={
                                                                isRequiredText
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-sm">
                                                        <Field
                                                            name="LastName"
                                                            label="Last name*"
                                                            component={
                                                                textField
                                                            }
                                                            validate={
                                                                isRequiredText
                                                            }
                                                            customDivClass={{
                                                                paddingLeft:
                                                                    "0px",
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <Field
                                                            name="reasonForContact"
                                                            component="select"
                                                            defaultValue=""
                                                            className="select-css"
                                                            validate={
                                                                isRequiredSelection
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <Fragment>
                                                                    <label
                                                                        className={
                                                                            meta.error &&
                                                                            meta.touched
                                                                                ? "mb-0 error"
                                                                                : "mb-0"
                                                                        }
                                                                    >
                                                                        Reason
                                                                        for
                                                                        contact*
                                                                    </label>
                                                                    <select
                                                                        {...input}
                                                                        className={
                                                                            meta.error &&
                                                                            meta.touched
                                                                                ? "select-css error"
                                                                                : "select-css"
                                                                        }
                                                                    >
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Not Selected"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Select
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="General Question"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;General
                                                                            Question
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Health Insurance Question"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Health
                                                                            Insurance
                                                                            Question
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Pharmacy Question"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Pharmacy
                                                                            Question
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Patient Assistance Question"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Patient
                                                                            Assistance
                                                                            Question
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Copay Assistance Question"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Copay
                                                                            Assistance
                                                                            Question
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Prior Authorization Question"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Prior
                                                                            Authorization
                                                                            Question
                                                                        </option>
                                                                        <option
                                                                            name="reasonForContact"
                                                                            defaultValue="Other"
                                                                        >
                                                                            &nbsp;&nbsp;&nbsp;&nbsp;Other
                                                                        </option>
                                                                    </select>
                                                                </Fragment>
                                                            )}
                                                        </Field>
                                                        <Field
                                                            name="reasonForContact"
                                                            component="input"
                                                            validate={
                                                                isRequired
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <Fragment>
                                                                    <input
                                                                        {...input}
                                                                        type="text"
                                                                        className="form-control full-width-input hidden-field"
                                                                        tabIndex="-1"
                                                                    />
                                                                    {meta.error &&
                                                                        meta.touched &&
                                                                        meta.error}
                                                                </Fragment>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <div className="row">
                                                            <div className="col">
                                                                <div className="row spacer-large mobile-sm" />
                                                                <Field
                                                                    name="preferredContact"
                                                                    component="input"
                                                                    validate={
                                                                        isRequiredQuestionSelection
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <label
                                                                                className={
                                                                                    meta.error &&
                                                                                    meta.touched
                                                                                        ? "error"
                                                                                        : "select-label"
                                                                                }
                                                                                htmlFor="preferredContact"
                                                                            >
                                                                                Preferred
                                                                                contact
                                                                                method*
                                                                            </label>
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-sm radio-email">
                                                                <div className="radio-field">
                                                                    <Field
                                                                        name="preferredContact"
                                                                        component="input"
                                                                        type="radio"
                                                                        value="email"
                                                                        className=""
                                                                        id="preferredContactEmail"
                                                                        onClick={() =>
                                                                            this.props.questionAnswer(
                                                                                "preferredContact",
                                                                                "email"
                                                                            )
                                                                        }
                                                                    />
                                                                    <label
                                                                        className=""
                                                                        htmlFor="preferredContactEmail"
                                                                    >
                                                                        Email
                                                                        address
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm radio-phone">
                                                                <div className="radio-field">
                                                                    <Field
                                                                        name="preferredContact"
                                                                        component="input"
                                                                        type="radio"
                                                                        value="phone"
                                                                        className=""
                                                                        id="preferredContactPhone"
                                                                        onClick={() =>
                                                                            this.props.questionAnswer(
                                                                                "preferredContact",
                                                                                "phone"
                                                                            )
                                                                        }
                                                                    />
                                                                    <label
                                                                        className=""
                                                                        htmlFor="preferredContactPhone"
                                                                    >
                                                                        Phone
                                                                        number
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm"></div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row spacer-medium spacer-mobile-30" />

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <Field
                                                            name="emailAddress"
                                                            label="Email address*"
                                                            component={
                                                                textField
                                                            }
                                                            forwardRef={
                                                                this
                                                                    .contactEmail
                                                            }
                                                            customDivClass={{
                                                                marginTop:
                                                                    "24px",
                                                            }}
                                                            key={
                                                                preferredContact ===
                                                                "email"
                                                                    ? 1
                                                                    : 0
                                                            }
                                                            validate={
                                                                isRequiredText
                                                            }
                                                        />
                                                    </div>

                                                    <div className="col-sm-6">
                                                        <div className="form-group pam-contact-number">
                                                            <Field
                                                                name="contactPhoneNumber"
                                                                component="input"
                                                                defaultValue={String(
                                                                    contactPhoneOne +
                                                                        contactPhoneTwo +
                                                                        contactPhoneThree
                                                                )}
                                                                key={
                                                                    preferredContact ===
                                                                    "phone"
                                                                        ? 1
                                                                        : 0
                                                                }
                                                                validate={
                                                                    isRequiredPhoneNumber
                                                                }
                                                            >
                                                                {({
                                                                    input,
                                                                    meta,
                                                                }) => (
                                                                    <Fragment>
                                                                        <input
                                                                            {...input}
                                                                            type="text"
                                                                            className="form-control full-width-input hidden-field"
                                                                            tabIndex="-1"
                                                                        />
                                                                        <label
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "error"
                                                                                    : ""
                                                                            }
                                                                            style={{
                                                                                marginBottom:
                                                                                    "0px",
                                                                            }}
                                                                        >
                                                                            Phone
                                                                            number*
                                                                        </label>
                                                                    </Fragment>
                                                                )}
                                                            </Field>
                                                            <div className="phone-group">
                                                                <Field
                                                                    name="contactPhoneOne"
                                                                    component="input"
                                                                    validate={
                                                                        isRequired
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                {...input}
                                                                                className={
                                                                                    meta.error &&
                                                                                    meta.touched
                                                                                        ? "form-control inline-phone phone-area-code error"
                                                                                        : "form-control inline-phone phone-area-code"
                                                                                }
                                                                                type="text"
                                                                                maxLength="3"
                                                                                placeholder="123"
                                                                                inputMode="numeric"
                                                                            />
                                                                            {meta.error &&
                                                                                meta.touched &&
                                                                                meta.error}
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <OnChange name="contactPhoneOne">
                                                                    {(
                                                                        value,
                                                                        previous
                                                                    ) => {
                                                                        if (
                                                                            numberValidator(
                                                                                value
                                                                            )
                                                                        ) {
                                                                            this.props.questionAnswer(
                                                                                "contactPhoneOne",
                                                                                value
                                                                            );
                                                                            if (
                                                                                value.length ===
                                                                                3
                                                                            ) {
                                                                                this.contactPhoneTwo.current.focus();
                                                                            }
                                                                        }
                                                                    }}
                                                                </OnChange>
                                                                <Field
                                                                    name="contactPhoneTwo"
                                                                    component="input"
                                                                    validate={
                                                                        isRequired
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                {...input}
                                                                                className={
                                                                                    meta.error &&
                                                                                    meta.touched
                                                                                        ? "form-control inline-phone phone-prefix error"
                                                                                        : "form-control inline-phone phone-prefix"
                                                                                }
                                                                                type="text"
                                                                                maxLength="3"
                                                                                placeholder="456"
                                                                                ref={
                                                                                    this
                                                                                        .contactPhoneTwo
                                                                                }
                                                                                inputMode="numeric"
                                                                            />
                                                                            {meta.error &&
                                                                                meta.touched &&
                                                                                meta.error}
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <OnChange name="contactPhoneTwo">
                                                                    {(
                                                                        value,
                                                                        previous
                                                                    ) => {
                                                                        if (
                                                                            numberValidator(
                                                                                value
                                                                            )
                                                                        ) {
                                                                            this.props.questionAnswer(
                                                                                "contactPhoneTwo",
                                                                                value
                                                                            );
                                                                            if (
                                                                                value.length ===
                                                                                3
                                                                            ) {
                                                                                this.contactPhoneThree.current.focus();
                                                                            }
                                                                        }
                                                                    }}
                                                                </OnChange>
                                                                <Field
                                                                    name="contactPhoneThree"
                                                                    component="input"
                                                                    validate={
                                                                        isRequired
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                {...input}
                                                                                className={
                                                                                    meta.error &&
                                                                                    meta.touched
                                                                                        ? "form-control inline-phone phone-line-number error"
                                                                                        : "form-control inline-phone phone-line-number"
                                                                                }
                                                                                type="text"
                                                                                maxLength="4"
                                                                                placeholder="7890"
                                                                                ref={
                                                                                    this
                                                                                        .contactPhoneThree
                                                                                }
                                                                                inputMode="numeric"
                                                                            />
                                                                            {meta.error &&
                                                                                meta.touched &&
                                                                                meta.error}
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <OnChange name="contactPhoneThree">
                                                                    {(
                                                                        value,
                                                                        previous
                                                                    ) => {
                                                                        if (
                                                                            numberValidator(
                                                                                value
                                                                            )
                                                                        ) {
                                                                            this.props.questionAnswer(
                                                                                "contactPhoneThree",
                                                                                value
                                                                            );
                                                                        }
                                                                    }}
                                                                </OnChange>
                                                                <Field
                                                                    name="phoneNumber"
                                                                    component="input"
                                                                    defaultValue={
                                                                        contactPhoneOne +
                                                                        contactPhoneTwo +
                                                                        contactPhoneThree
                                                                    }
                                                                    validate={
                                                                        isRequiredPhoneNumber
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                {...input}
                                                                                type="text"
                                                                                className="form-control full-width-input hidden-field"
                                                                                tabindex="-1"
                                                                            />
                                                                            {meta.error &&
                                                                                meta.touched &&
                                                                                meta.error}
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <Field
                                                                    name="pamEmailSendTo"
                                                                    component="input"
                                                                    defaultValue={
                                                                        this
                                                                            .state
                                                                            .data
                                                                            .email
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .data
                                                                                        .email
                                                                                }
                                                                                {...input}
                                                                                type="text"
                                                                                className="form-control full-width-input hidden-field"
                                                                                tabindex="-1"
                                                                            />
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <Field
                                                                    name="pamFirstName"
                                                                    component="input"
                                                                    defaultValue={
                                                                        this
                                                                            .state
                                                                            .data
                                                                            .firstName
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .data
                                                                                        .email
                                                                                }
                                                                                {...input}
                                                                                type="text"
                                                                                className="form-control full-width-input hidden-field"
                                                                                tabindex="-1"
                                                                            />
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <Field
                                                                    name="pamLastInitial"
                                                                    component="input"
                                                                    defaultValue={
                                                                        this
                                                                            .state
                                                                            .data
                                                                            .lastInitial
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .data
                                                                                        .lastInitial
                                                                                }
                                                                                {...input}
                                                                                type="text"
                                                                                className="form-control full-width-input hidden-field"
                                                                                tabindex="-1"
                                                                            />
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                                <Field
                                                                    name="pamZip"
                                                                    component="input"
                                                                    defaultValue={
                                                                        this
                                                                            .state
                                                                            .data
                                                                            .zip
                                                                    }
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <Fragment>
                                                                            <input
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .data
                                                                                        .zip
                                                                                }
                                                                                {...input}
                                                                                type="text"
                                                                                className="form-control full-width-input hidden-field"
                                                                                tabindex="-1"
                                                                            />
                                                                        </Fragment>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row spacer-medium" />

                                                <div className="row">
                                                    <div className="col">
                                                        <Field
                                                            name="message"
                                                            label={"Message*"}
                                                            component={
                                                                textareaField
                                                            }
                                                            customInputClass={{
                                                                height: "200px",
                                                                marginTop:
                                                                    "0px",
                                                            }}
                                                            customDivClass={{
                                                                paddingLeft:
                                                                    "0",
                                                                marginBottom:
                                                                    "0",
                                                                top: "-9px",
                                                            }}
                                                            validate={
                                                                isRequiredTextarea
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row spacer-medium" />
                                                <div className="row">
                                                    <div className="col text-right">
                                                        <button
                                                            id="pam-lookup-send-contact-email"
                                                            className="button blue mr-2"
                                                            type="button"
                                                            onClick={
                                                                handleSubmit
                                                            }
                                                        >
                                                            Send Message
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal modal-fade"
                    id="confirmEmail"
                    tabIndex=""
                    role="dialog"
                    aria-labelledby=""
                    aria-hidden="true"
                    style={{ display: this.state.modalConfirmDisplay }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <div className="container blue-bg">
                                <div className="modal-header">
                                    <p
                                        className="modal-title white-font-26-euclid"
                                        id="exampleModalLongTitle"
                                    >
                                        Patient Access Manager CONTACT REQUEST
                                    </p>
                                    <button
                                        type="button"
                                        className="close modal-close-x"
                                        onClick={() =>
                                            this.closeConfirmModalDialog()
                                        }
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="row spacer-small" />
                                <div className="row spacer-medium" />
                                <h3 className="blue-font-35-gelo">
                                    Thank you for reaching out.{" "}
                                    {this.state.data.firstName} has received
                                    your message and will reply by the end of
                                    the next business day.
                                </h3>
                                <div className="row spacer-xsmall" />
                                <button
                                    id="pam-lookup-contact-email-recieved"
                                    className="button blue"
                                    type="button"
                                    onClick={() =>
                                        this.closeConfirmModalDialog()
                                    }
                                >
                                    CLOSE
                                </button>
                                <div className="row spacer-medium" />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps, actions)(PAMLookup);
